import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GridService } from '../shared/grid/grid.service';
import { ControlOrganizationLevelSeg } from '../models/controlOrganizationLevelSeg.model';

@Injectable({
    providedIn: 'root'
})
export class ControlOrganizationLevelSegService extends GridService<ControlOrganizationLevelSeg> {

    constructor(http: HttpClient) {
        super('ControlOrganizationLevelSeg', http);
    }
}
